import React, { useState } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const OrderCell = (orders) => {
  const [accordingOn, setAccordingOn] = useState(false)
  const { token, distribution_status } = useSelector((state) => state.auth)
  const dustributionStatus = distribution_status?.value?.status_list
  const printStatus = distribution_status?.value?.printing_status_list

  const navigate = useNavigate()
  const toDetail = (orderId) => {
    navigate(`/order/detail/${orderId}`)
  }
  // console.log(orders.orders[0]);

  const triggerAcc = () => {
    setAccordingOn(!accordingOn)
  }

  let order = orders.orders
  let sum = order.reduce((accumulator, currentValue) => {
    return accumulator + currentValue?.estimation?.quantity
  }, 0)

  return (
    <>
      <tr
        onClick={triggerAcc}
        className="text-center text-sm border-[1px] border-gray-400 bg-gray-100 hover:bg-gray-800 hover:text-white cursor-pointer"
      >
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
          {order[0]?.created_at}{' '}
        </td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]"></td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]"></td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
          {/* {order?.data_type === 'orikomi_print' ? (
            <>
            {printStatus?.map(
              (status, idx) => idx === order?.printing_status && status
            )}
            </>
          ) : '-'} */}
        </td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
          {order[0]?.extra?.company?.name}
        </td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
          {order[0]?.user_id}
        </td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]"></td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
          {sum}
        </td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
          {order?.insertion_date}
        </td>
        <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]"></td>
        <td className="w-max overflow-x-auto  border-x-[1px] border-gray-400 py-2 px-[2px]">
          <div className="flex justify-center items-center">
            <div className="bg-[#2A7FFF] w-6 h-6 rounded-full text-white flex justify-center items-center pt-[2px] font-bold mr-1">
              {order.length}
            </div>
            {accordingOn ? (
              <FiChevronUp size={20} />
            ) : (
              <FiChevronDown size={20} />
            )}
          </div>
        </td>
      </tr>
      {accordingOn &&
        order.map((data) => (
          <tr
            key={data?.order_key}
            onClick={() => toDetail(data?.order_key)}
            className="text-center text-sm border-[1px] border-gray-400 bg-gray-300 hover:bg-gray-800 hover:text-white cursor-pointer"
          >
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {data?.created_at}{' '}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {data?.order_key}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {/* {order?.data_type === 'orikomi_print' ? (
                <>
                {printStatus?.map(
                  (status, idx) => idx === order?.printing_status && status
                )}
                </>
              ) : '-'} */}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {dustributionStatus?.map(
                (status, idx) => idx === data?.status && status
              )}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {data?.extra?.company?.name}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {data?.user_id}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {data?.extra?.points?.length > 0 ? data?.extra?.points : ''}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {data?.estimation?.quantity}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {data?.insertion_date}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]">
              {order?.extra?.sync?.product_name}
            </td>
            <td className="w-max overflow-x-auto border-x-[1px] border-gray-400 py-2 px-[2px]"></td>
          </tr>
        ))}
    </>
  )
}

export default OrderCell
